// extracted by mini-css-extract-plugin
export default {"back2Top":"Footer_back2Top__RJ34A"};